<sh-main-nav-single-item
  [item]="items.newsfeedItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
<sh-main-nav-single-item
  [item]="items.ranksOverviewItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
<!-- <sh-main-nav-single-item
  [item]="items.topIndustriesItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item> -->

<a
  [attr.title]="'header.business-page' | transloco"
  [routerLink]="items.businessPageRootLink"
  (click)="onCloseMenu()">
  <button
    class="nav-item-button"
    color="accent"
    mat-stroked-button>
    {{ 'header.business-page' | transloco }}
  </button>
</a>
